import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import axios from 'axios';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEye, faTrash, faPen } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

import AdminPageContainer from '../common/AdminPageContainer';
import Loader from '../../common/loader/Loader';

import { BackLink } from '../common/Buttons';
import ConfirmationModal, { useConfirmationModal } from '../../common/modals/ConfirmationModal';

import { getCourseImage, courseLevelToString } from '../../../utils/course-utils';
import { checkUserAuth } from '../../../utils/auth-utils';

const AdminCoursesPage = props => {
  const { token } = useSelector(state => state);
  const [isLoading, setIsLoading] = useState(false);
  const [courses, setCourses] = useState([]);

  const loadData = () => {
    setIsLoading(true);
    axios
      .get('/api/v1/courses')
      .then(r => {
        setCourses(r.data.courses);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const deleteConfirmation = useConfirmationModal();

  const openDeleteConfirmation = id => () => {
    deleteConfirmation.open(() => () => {
      setCourses(courses.filter(x => x._id !== id));
      axios
        .delete(`api/v1/courses/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .catch(e => {
          checkUserAuth(e, props.history);
        });
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <AdminPageContainer>
      <Loader isVisible={isLoading} />
      <ConfirmationModal state={deleteConfirmation} />
      <div className="is-flex">
        <BackLink to="/admin" />
        <Link to="/admin/courses/add" className="button is-link ml-20px">
          <FontAwesomeIcon icon={faPlus} />
          <p className="ml-10px">New course</p>
        </Link>
      </div>

      <div className="mt-20px">
        {courses.map(course => (
          <div key={course._id} className="admin-table-row">
            <div className="is-flex align-items-center">
              <img src={getCourseImage(course.type)} className="admin-course-image" alt="Course icon" />
              <div className="ml-20px">
                <p className="admin-table-row-title">{course.name}</p>
                <p>
                  webinars: <strong>{_.sumBy(course.sections, x => x.webinars.length)}</strong>; price:{' '}
                  <strong>{course.price}€</strong>; Level: <strong>{courseLevelToString(course.level)}</strong>
                </p>
              </div>
            </div>
            <div className="is-flex mt-10px">
              <Link to={`/course/${course._id}`} className="button is-info" title="View course">
                <FontAwesomeIcon icon={faEye} />
              </Link>
              <Link to={`/admin/courses/edit/${course._id}`} className="button is-link ml-10px" title="Edit course">
                <FontAwesomeIcon icon={faPen} />
              </Link>
              <button
                className="button is-danger ml-10px"
                onClick={openDeleteConfirmation(course._id)}
                title="Delete course"
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </AdminPageContainer>
  );
};

AdminCoursesPage.propTypes = {
  history: PropTypes.object.isRequired,
};

export default AdminCoursesPage;
